import script from "./PersonCardComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonCardComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PersonCardComponent.vue?vue&type=style&index=0&id=71ab24f7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71ab24f7"]])

export default __exports__